"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _jsxRuntime = require("react/jsx-runtime");
var _templateObject;
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var SwiftGridCol = function SwiftGridCol(_ref) {
  var className = _ref.className,
    id = _ref.id,
    inline = _ref.inline,
    children = _ref.children,
    spacing = _ref.spacing,
    breakpoints = _ref.breakpoints,
    _ref$widths = _ref.widths,
    widths = _ref$widths === void 0 ? ["auto"] : _ref$widths,
    flex = _ref.flex,
    offsets = _ref.offsets,
    _ref$maxColumnCount = _ref.maxColumnCount,
    maxColumnCount = _ref$maxColumnCount === void 0 ? 12 : _ref$maxColumnCount;
  // Breakpoints
  var breakpointOne = breakpoints[0];
  var breakpointTwo = breakpoints.length >= 1 ? breakpoints[1] : null;
  var breakpointThree = breakpoints.length >= 2 ? breakpoints[2] : null;

  // Widths
  var widthOne = widths[0];
  var widthTwo = widths.length >= 1 ? widths[1] : null;
  var widthThree = widths.length >= 2 ? widths[2] : null;

  // Offsets
  var offsetOne = offsets && offsets.length > 0 ? offsets[0] : null;
  var offsetTwo = offsets && offsets.length >= 1 ? offsets[1] : null;
  var offsetThree = offsets && offsets.length >= 2 ? offsets[2] : null;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(Wrapper, {
    breakpointOne: breakpointOne,
    breakpointTwo: breakpointTwo,
    breakpointThree: breakpointThree,
    widthOne: widthOne,
    widthTwo: widthTwo,
    widthThree: widthThree,
    offsetOne: offsetOne,
    offsetTwo: offsetTwo,
    offsetThree: offsetThree,
    inline: inline,
    flex: flex,
    spacingX: spacing[0],
    spacingY: typeof spacing[1] === "number" ? spacing[1] : spacing[0]
    //key={key}
    ,
    className: className,
    children: children
  });
};
var Wrapper = _styledComponents.default.div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  width: 100%;\n\n  ", "\n"])), function (props) {
  return props.inline ? "flex: ".concat(props.flex || 0, ";") : "\n    flex: 1 1 0;\n    flex-basis: ".concat(12 / props.maxColumnCount / 12 * 100, "% !important;\n    padding: ").concat(props.spacingY, "px ").concat(props.spacingX, "px;\n\n    @media (min-width: ").concat(props.breakpointOne, "px) and (max-width: ").concat(props.breakpointTwo || 9999, "px) {\n      width: ").concat(props.widthOne !== "auto" ? "".concat(props.widthOne / 12 * 100, "%") : null, ";\n      flex: ").concat(props.widthOne !== "auto" ? "none !important" : null, ";\n      margin-left: ").concat(props.offsetOne ? "".concat(props.offsetOne / 12 * 100, "% !important") : null, ";\n    }\n\n    @media (min-width: ").concat(props.breakpointTwo, "px) and (max-width: ").concat(props.breakpointThree || 9999, "px) {\n      width: ").concat(props.widthTwo !== "auto" ? "".concat(props.widthTwo / 12 * 100, "%") : null, ";\n      flex: ").concat(props.widthTwo !== "auto" ? "none !important" : null, ";\n      margin-left: ").concat(props.offsetTwo ? "".concat(props.offsetTwo / 12 * 100, "% !important") : null, ";\n    }\n\n    @media (min-width: ").concat(props.breakpointThree, "px) and (max-width: 99999px) {\n      width: ").concat(props.widthThree !== "auto" ? "".concat(props.widthThree / 12 * 100, "%") : null, ";\n      flex: ").concat(props.widthThree !== "auto" ? "none !important" : null, ";\n      margin-left: ").concat(props.offsetThree ? "".concat(props.offsetThree / 12 * 100, "% !important") : null, ";\n    }\n    ");
});
var _default = SwiftGridCol;
exports.default = _default;